import React from "react";
import { Link } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { useTranslation } from "react-i18next";
import PharmacyHeading from "../PharmacyHeading";
import Heading from "../../Fashion/Heading";
import LiteYouTubeEmbed from "react-lite-youtube-embed";
import "react-lite-youtube-embed/dist/LiteYouTubeEmbed.css";

const Videos = (props) => {
  const { t, i18n } = useTranslation();
  let settings = {
    arrows: false,
    dots: true,
    margin: 30,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 6,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <>
      <section
        id="pharmacy_categorie"
        className="ptb-100 pt-0 pb-5 slider_button_left_right"
      >
        <div className="container">
          <Heading heading={t("ourvideos")} para={t("exploremore")} />
          <div className="row position-relative">
            <div className="col-lg-12">
              <Slider {...settings}>
                {props.data.map((data, index) => (
                  <div className="px-2">
                    {/* <iframe className="w-100" frameborder="0" height="180"  allowFullScreen 
                       src={data.tag+'?autoplay=0&disablekb=1&loop=1&modestbranding=1&rel=0&playsinline=1&color=white&&rel=0&showinfo=0'}>
 
                     </iframe> */}
                    <LiteYouTubeEmbed
                      id={data.tag}
                      title="What’s new in Material Design for the web (Chrome Dev Summit 2019)"
                    />
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Videos;
